import * as React from "react";
import type { SVGProps } from "react";
const SvgBookmarkStar = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.569 6.246a.5.5 0 0 1 .862 0l1.034 1.682c.07.113.177.194.302.228l1.85.508c.361.099.503.555.267.857l-1.212 1.547a.55.55 0 0 0-.115.37l.11 1.995c.021.39-.35.672-.698.53l-1.783-.726a.5.5 0 0 0-.372 0l-1.783.726c-.348.142-.72-.14-.698-.53l.11-1.995a.55.55 0 0 0-.115-.37L8.116 9.52c-.236-.302-.094-.758.267-.857l1.85-.508a.52.52 0 0 0 .302-.228zm.243 2.467L12 8.408l.188.305c.262.427.68.752 1.182.89l.448.123-.327.417c-.31.396-.458.887-.431 1.377l.025.464-.333-.136a2 2 0 0 0-1.504 0l-.333.136.026-.464a2.05 2.05 0 0 0-.432-1.377l-.327-.417.448-.123c.503-.138.92-.463 1.182-.89"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 2.25A3.75 3.75 0 0 0 3.25 6v12.146c0 1.329.599 2.432 1.626 2.887 1.042.461 2.248.136 3.191-.823.452-.46.959-.981 1.528-1.574a3.34 3.34 0 0 1 4.81 0c.57.593 1.076 1.114 1.528 1.574.943.959 2.15 1.284 3.191.823 1.027-.455 1.626-1.558 1.626-2.887V6A3.75 3.75 0 0 0 17 2.25zM4.75 6A2.25 2.25 0 0 1 7 3.75h10A2.25 2.25 0 0 1 19.25 6v12.146c0 .901-.386 1.362-.733 1.515-.334.148-.894.128-1.515-.503-.447-.455-.95-.972-1.515-1.56a4.84 4.84 0 0 0-6.974 0c-.565.588-1.068 1.105-1.515 1.56-.621.63-1.181.651-1.515.503-.347-.153-.733-.614-.733-1.515z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBookmarkStar;
